import React from "react";
import {
  Box,
  Container,
  Header,
  SpaceBetween,
  Spinner,
  Badge,
  ColumnLayout,
} from "@amzn/awsui-components-react";

import aiAwareBadge from "../../images/raise-badges/ai-aware.png";
import aiEnabledBadge from "../../images/raise-badges/ai-enabled.png";
import aiChampionBadge from "../../images/raise-badges/ai-champion.png";

// Bundled badge art keyed by tier code. (AI Builder is intentionally excluded —
// it isn't one of the three tiers.)
const BADGE_BY_TIER = {
  AI_AWARE: aiAwareBadge,
  AI_ENABLED: aiEnabledBadge,
  AI_CHAMPION: aiChampionBadge,
};

/**
 * Get Certified: one badge per tier. Certifications launch Q4 2026 for AI Aware
 * and AI Enabled. Badge art is bundled and mapped by tier code; a placeholder
 * shows for any tier without a mapped badge.
 */
const GetCertified = ({ certifications, intro }) => {
  if (!certifications) {
    return (
      <Box padding="l">
        <Spinner /> Loading certifications...
      </Box>
    );
  }

  const certs = [...certifications].sort(
    (a, b) => (a.sort_order || 0) - (b.sort_order || 0)
  );

  return (
    <SpaceBetween size="l">
      <Box variant="p">
        {intro ||
          "Certifications will be launched in Q4 2026 for AI Aware and AI Enabled, allowing you to validate your skillset."}
      </Box>
      <ColumnLayout columns={certs.length || 1}>
        {certs.map((cert) => {
          const badge = BADGE_BY_TIER[cert.tier_code];
          return (
          <Container
            key={cert.certification_id}
            header={<Header variant="h3">{cert.tier_name}</Header>}
          >
            <SpaceBetween size="s" alignItems="center">
              <Box
                className="raise-badge-placeholder"
                textAlign="center"
                padding="l"
                color="text-body-secondary"
              >
                {badge ? (
                  <img
                    src={badge}
                    alt={`${cert.tier_name} certified badge`}
                    style={{ maxWidth: "160px", width: "100%" }}
                  />
                ) : (
                  "Badge"
                )}
              </Box>
              <Box textAlign="center">{cert.audience_label}</Box>
              <Badge color={cert.status === "LAUNCHED" ? "green" : "blue"}>
                {cert.status === "LAUNCHED"
                  ? "Available"
                  : cert.launch_label || "Upcoming"}
              </Badge>
            </SpaceBetween>
          </Container>
          );
        })}
      </ColumnLayout>
    </SpaceBetween>
  );
};

export default GetCertified;
